import InstaIcon from "assets/icons/insta.svg";
import SpotifyIcon from "assets/icons/spotify.svg";
import TwitterIcon from "assets/icons/x.svg";
import AppleIcon from "assets/icons/apple.svg";
import FacebookIcon from "assets/icons/facebook.svg";
import TiktokIcon from "assets/icons/tiktok.svg";
import CloudIcon from "assets/icons/cloud.svg";
import YoutubeIcon from "assets/icons/youtube.svg";
import { VariableKeys } from "./VariableKeys";

export const capitalizeCamelCase = (str) => {
    if (str) {
        return str
            .replace(/([a-z])([A-Z])/g, "$1 $2") // Convert camelCase to space-separated
            .replace(/_/g, " ") // Convert snake_case to spaces
            .replace(/^\w/, (c) => c.toUpperCase()) // Capitalize the first letter
            .replace(/\b\w/g, (char) => char.toUpperCase());
    }
};

export const getSocialLinkIcon = (type) => {
    switch (type) {
        case "x":
        case "X":
            return TwitterIcon;

        case "Instagram":
            return InstaIcon;

        case "Facebook":
            return FacebookIcon;

        case "Tiktok":
            return TiktokIcon;

        case "Spotify":
            return SpotifyIcon;

        case "Apple":
        case "appleMusic":
            return AppleIcon;

        case "Youtube":
            return YoutubeIcon;

        case "Soundcloud":
            return CloudIcon;

        default:
            break;
    }
}

export const getColor = (value) => {
    switch (value) {
        case "IN_PROGRESS":
        case "In Progress":
            return "#E5B403"
        case "DRAFT":
            return "Draft"
        case "COMPLETED":
        case "Completed":
        case "ACTIVE":
            return "#96A13D"
        case "NOT_STARTED":
        case "Not Started":
            return "#C4C4C4"
        default:
            return "#C4C4C4";
    }
}

export const getStatus = (status) => {
    switch (status) {
        case "ACTIVE":
            return "Active"
        case "IN_PROGRESS":
            return "In Progress"
        case "DRAFT":
            return "Draft"
        case "COMPLETED":
            return "Completed"
        case "NOT_STARTED":
            return "Not Started"
        default:
            return "In Progress";
    }
}

export const handleFormatDate = (value, action) => {
    if (value) {
        let date = new Date(value);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let dt = date.getDate();
        if (dt < 10) {
            dt = "0" + dt;
        }
        if (month < 10) {
            month = "0" + month;
        }

        let formattedDate = "";

        if (action === "year") {
            formattedDate = year;
        } else if (action === VariableKeys.FULL_MONTH) {
            formattedDate = value.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });

        } else {
            formattedDate = year + "-" + month + "-" + dt;
            // formattedDate = dt + "." + month + "." + year;
            // formattedDate = dt + "-" + month + "-" + year;
        }
        return formattedDate;
    }
};

export const formatDateToMMDDYYYY = (isoDateString) => {
    if (!isoDateString) return '';
    
    const date = new Date(isoDateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${month}/${day}/${year}`;
  }

export const handleFileConversion = (file) => {
    return new Promise((resolve, reject) => {
        if (file && typeof file === "object") {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                resolve(`${file?.name};base64,${base64String}`);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        } else {
            resolve(file); // or reject with an appropriate message if needed
        }
    });
};